// @flow
import {
  TICKET_LIST,
  TICKET_LIST_SUCCESS,
  TICKET_LIST_FAILED,
  SKILL_LIST,
  SKILL_LIST_SUCCESS,
  SKILL_LIST_FAILED,
  SKILL_UPDATE,
  SKILL_UPDATE_SUCCESS,
  SKILL_UPDATE_FAILED,
  DAILY_REPORT_LIST,
  DAILY_REPORT_LIST_SUCCESS,
  DAILY_REPORT_LIST_FAILED,
  WEEKLY_REPORT_LIST,
  WEEKLY_REPORT_LIST_SUCCESS,
  WEEKLY_REPORT_LIST_FAILED,
  MONTHLY_REPORT_LIST,
  MONTHLY_REPORT_LIST_SUCCESS,
  MONTHLY_REPORT_LIST_FAILED,
  WORKSHEET_TICKET_LIST,
  WORKSHEET_TICKET_LIST_SUCCESS,
  WORKSHEET_TICKET_LIST_FAILED,
  DAILY_REPORT_ADD,
  DAILY_REPORT_ADD_SUCCESS,
  DAILY_REPORT_ADD_FAILED,
  WEEKLY_REPORT_ADD,
  WEEKLY_REPORT_ADD_SUCCESS,
  WEEKLY_REPORT_ADD_FAILED,
  MONTHLY_REPORT_ADD,
  MONTHLY_REPORT_ADD_SUCCESS,
  MONTHLY_REPORT_ADD_FAILED,
  TICKET_UPDATE,
  TICKET_UPDATE_SUCCESS,
  TICKET_UPDATE_FAILED,
  TICKET_DATA,
  TICKET_DATA_SUCCESS,
  TICKET_DATA_FAILED,
  VIEW_REPORT,
  VIEW_REPORT_SUCCESS,
  VIEW_REPORT_FAILED,
  CLIENT,
  CLIENT_SUCCESS,
  CLIENT_FAILED,
  ATTACH_UPDATE,
  ATTACH_UPDATE_SUCCESS,
  ATTACH_UPDATE_FAILED,
  MANDATORY_REPORT_ADD,
  MANDATORY_REPORT_ADD_SUCCESS,
  MANDATORY_REPORT_ADD_FAILED,
  
  ATTACH_PERFORMANCE,
  ATTACH_PERFORMANCE_SUCCESS,
  ATTACH_PERFORMANCE_FAILED,

  FDC_MQ_SAVE,
  FDC_MQ_SAVE_SUCCESS,
  FDC_MQ_SAVE_FAILED,
  FDC_MQ_LIST,
  FDC_MQ_LIST_SUCCESS,
  FDC_MQ_LIST_FAILED,
  FDC_MQ_DELETE,
  FDC_MQ_DELETE_SUCCESS,
  FDC_MQ_DELETE_FAILED,
  FDC_MQ_UPDATE,
  FDC_MQ_UPDATE_SUCCESS,
  FDC_MQ_UPDATE_FAILED,

} from "./constants";

import { getLoggedInUser } from "../../helpers/authUtils";

const INIT_STATE = {
  user: getLoggedInUser(),
  loading: false,
};

const Worksheet = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TICKET_LIST:
      return { ...state, listloading: true };
    case TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticket: action.payload,
        fdcMqSummary: action.payload?.data?.fdc_mq_summary || state.fdcMqSummary,
        listloading: false,
        error: null,
      };
    case TICKET_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case TICKET_DATA:
      return { ...state };
    case TICKET_DATA_SUCCESS:
      return {
        ...state,
        ticketData: action.payload,
        listloading: false,
        error: null,
      };
    case TICKET_DATA_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case TICKET_UPDATE:
      return { ...state };
    case TICKET_UPDATE_SUCCESS:
      return {
        ...state,
        ticketUpdate: action.payload,
        error: null,
      };
    case TICKET_UPDATE_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case SKILL_LIST:
      return { ...state, listloading: true };
    case SKILL_LIST_SUCCESS:
      return {
        ...state,
        skill: action.payload,
        listloading: false,
        error: null,
      };
    case SKILL_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case SKILL_UPDATE:
      return { ...state, listloading: true };
    case SKILL_UPDATE_SUCCESS:
      return {
        ...state,
        skillUpdate: action.payload,
        listloading: false,
        error: null,
      };
    case SKILL_UPDATE_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case DAILY_REPORT_LIST:
      return { ...state, listloading: true };
    case DAILY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        dailyReport: action.payload,
        listloading: false,
        error: null,
      };
    case DAILY_REPORT_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case DAILY_REPORT_ADD:
      return { ...state };
    case DAILY_REPORT_ADD_SUCCESS:
      return {
        ...state,
        dailyReportAdd: action.payload,
        error: null,
      };
    case DAILY_REPORT_ADD_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case WEEKLY_REPORT_LIST:
      return { ...state, listloading: true };
    case WEEKLY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        weeklyReport: action.payload,
        listloading: false,
        error: null,
      };
    case WEEKLY_REPORT_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case WEEKLY_REPORT_ADD:
      return { ...state };
    case WEEKLY_REPORT_ADD_SUCCESS:
      return {
        ...state,
        WeeklyReportAdd: action.payload,
        error: null,
      };
    case WEEKLY_REPORT_ADD_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case MONTHLY_REPORT_LIST:
      return { ...state, listloading: true };
    case MONTHLY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        monthlyReport: action.payload,
        listloading: false,
        error: null,
      };
    case MONTHLY_REPORT_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        listloading: false,
        loading: false,
      };
    case MONTHLY_REPORT_ADD:
      return { ...state };
    case MONTHLY_REPORT_ADD_SUCCESS:
      return {
        ...state,
        MonthlyReportAdd: action.payload,
        error: null,
      };
    case MONTHLY_REPORT_ADD_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case WORKSHEET_TICKET_LIST:
      return { ...state };
    case WORKSHEET_TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticketList: action.payload,
        error: null,
      };
    case WORKSHEET_TICKET_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case VIEW_REPORT:
      return { ...state};
    case VIEW_REPORT_SUCCESS:
      return {
        ...state,
        report: action.payload,
        error: null,
      };
    case VIEW_REPORT_FAILED:
      return {
        ...state,
        error: action.payload,
      };

      case CLIENT:
        return { ...state, listloading: true };
      case CLIENT_SUCCESS:
        return {
          ...state,
          client: action.payload,
          listloading: false,
          error: null,
        };
      case CLIENT_FAILED:
        return {
          ...state,
          error: action.payload,
          listloading: false,
          loading: false,
        };

        case ATTACH_UPDATE:
          return { ...state };
        case ATTACH_UPDATE_SUCCESS:
          return {
            ...state,
            attachList: action.payload,
            error: null,
          };
        case ATTACH_UPDATE_FAILED:
          return {
            ...state,
            error: action.payload,
          };




          case ATTACH_PERFORMANCE:
            return { ...state };
          case ATTACH_PERFORMANCE_SUCCESS:
            return {
              ...state,
              attachPerformance: action.payload,
              error: null,
            };
          case ATTACH_PERFORMANCE_FAILED:
            return {
              ...state,
              error: action.payload,
            };


            case MANDATORY_REPORT_ADD:
              return { ...state };
            case MANDATORY_REPORT_ADD_SUCCESS:
              return {
                ...state,
                mandAdd: action.payload,
                error: null,
              };
            case MANDATORY_REPORT_ADD_FAILED:
              return {
                ...state,
                error: action.payload,
              };

            // FDC MQ
            case FDC_MQ_SAVE:
              return { ...state, fdcMqSaving: true };
            case FDC_MQ_SAVE_SUCCESS:
              return {
                ...state,
                fdcMqSaveResult: action.payload,
                fdcMqSaving: false,
                error: null,
              };
            case FDC_MQ_SAVE_FAILED:
              return {
                ...state,
                error: action.payload,
                fdcMqSaving: false,
              };
            case FDC_MQ_LIST:
              return { ...state, fdcMqLoading: true };
            case FDC_MQ_LIST_SUCCESS:
              return {
                ...state,
                fdcMqEntries: action.payload,
                fdcMqLoading: false,
                error: null,
              };
            case FDC_MQ_LIST_FAILED:
              return {
                ...state,
                error: action.payload,
                fdcMqLoading: false,
              };
            case FDC_MQ_DELETE:
              return { ...state };
            case FDC_MQ_DELETE_SUCCESS:
              return {
                ...state,
                fdcMqDeleteResult: action.payload,
                error: null,
              };
            case FDC_MQ_DELETE_FAILED:
              return {
                ...state,
                error: action.payload,
              };
            case FDC_MQ_UPDATE:
              return { ...state, fdcMqSaving: true };
            case FDC_MQ_UPDATE_SUCCESS:
              return {
                ...state,
                fdcMqUpdateResult: action.payload,
                fdcMqSaving: false,
                error: null,
              };
            case FDC_MQ_UPDATE_FAILED:
              return {
                ...state,
                error: action.payload,
                fdcMqSaving: false,
              };

    default:
      return { ...state };
  }
};

export default Worksheet;
